<template>
  <el-col :xs="properties.xs" :sm="properties.sm" :md="properties.md" :lg="properties.lg" :xl="properties.xl" :data-pc-key="config.key" draggable="true" :title="config.desc || config.text">
    <div :class="getClass()" :style="getStyle()">
      <drop-position :text="getShowText()" :dropMode="dropMode" @remove="triggerRemove" @clone="clone"></drop-position>
      <component v-for="c in children" :key="c.key" :is="c.configComponent" :endpoint="endpoint" :group="group" :config="c" ref="childComponents" @remove="removeChild"></component>
    </div>
  </el-col>
</template>

<script>
import mixin from './mixin.js'

export default {
  name: 'pc-col-component',
  mixins: [mixin],
  data () {
    return {
      properties: {
        xs: null,
        sm: null,
        md: null,
        lg: null,
        xl: null
      }
    }
  }
}
</script>
